<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width organization-autocomplete"
               remote
               :loading="loading"
               :placeholder="$t('generic.search')"
               :remote-method="onRemoteMethod"
               :value="organizationValue"
               clearable
               :allow-create="allowCreate"
               filterable
               default-first-option
               @change="onChange"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="organization in organizations.data"
                 class="select-default organization-autocomplete__option"
                 :key="organization.id"
                 :label="organization.name"
                 :value="organization">
        <div class="d-flex align-items-center">
          <img class="mr-2 option-image-sm" v-if="organization.logo" :src="organization.logo" :alt="organization.name">
          <span>{{organization.name}}</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import ClientService from '@/services/ClientService'
  import { Select, Option } from 'element-ui'
  import throttle from 'lodash/throttle'
  import OrganizationService from 'src/services/OrganizationService'

  export default {
    name: 'organization-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      organization: {
        type: Object,
        default: () => {
          return {
            name: ''
          }
        }
      },
      searchParams: {
        type: Object,
        default: () => ({})
      },
      label: {
        type: String
      },
      allowCreate: Boolean,
      excludeOrganizations: {
        type: Array,
        default: () => []
      }
    },
    model: {
      prop: 'organization',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        organizations: []
      }
    },
    computed: {
      organizationValue () {
        if (!this.organization) {
          return null
        }
        if (!this.organization.id) {
          return this.organization.name
        }
        return this.organization
      }
    },
    methods: {
      async searchOrganizations (query) {
        try {
          this.loading = true
          let results = await OrganizationService.get({query, limit: 20, 'match[active]': true, ...this.searchParams})
          results.data = results.data.filter(org => {
            return this.excludeOrganizations.find(o => o.id === org.id) === undefined
          })
          this.organizations = results
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      },
      async onChange (val) {
        if (!val) {
          this.onRemoteMethod(val)
        }
        let model = val
        if (typeof val === 'string') {
          model = await this.createNewOrganization(val)
          await this.searchOrganizations(val)
        }
        this.$emit('change', model)
      },
      async createNewOrganization(name) {
        const { data } = await OrganizationService.create({
          name: name,
          active: true,
        })
        return data
      }
    },
    created () {
      this.onRemoteMethod = throttle(this.searchOrganizations, 200)
    },
    async mounted () {
      let name = this.organization ? this.organization.name : ''
      await this.searchOrganizations(name)
      if (name) {
        let model = this.organizations.data.find(c => c.name === this.organization.name)
        if (model) {
          this.onChange(model)
        }
      }
    }
  }
</script>
<style lang="scss">
  .option-image-sm {
    width: auto;
    height: auto;
    max-height: 40px;
    max-width: 120px;
  }

  .client-autocomplete {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }

  .el-select-dropdown .el-select-dropdown__item.organization-autocomplete__option {
    height: 50px;
    line-height: 42px;
    border-bottom: 1px solid $hr-line;
  }
</style>
